const lbPoiSelect = angular.module('app.lbPoiSelect', []);

lbPoiSelect.controller('lbPoiSelectCtrl', require('./lbPoiSelectCtrl'));
lbPoiSelect.component('lbPoiSelect', require('./lbPoiSelect'));
lbPoiSelect.filter('poiHighlightFilter', require('./poiHighlightFilter'));

export default lbPoiSelect;



// WEBPACK FOOTER //
// ./src/components/lbPoiSelect/index.js